import { render, staticRenderFns } from "./BusinessCardOnDevice.vue?vue&type=template&id=2cb0d817&scoped=true"
import script from "./BusinessCardOnDevice.vue?vue&type=script&lang=js"
export * from "./BusinessCardOnDevice.vue?vue&type=script&lang=js"
import style0 from "./BusinessCardOnDevice.vue?vue&type=style&index=0&id=2cb0d817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0d817",
  null
  
)

export default component.exports